import BaseTracker from './BaseTracker';
// 获取唯一标识的参数
const UNIQUE_SIGN = 'trackid';
const TRACKER_CONFIG_BASE_URL = 'https://mauloan.ppdaicdn.com/tracker/';
export default class POINTS extends BaseTracker {
    constructor(activityType, options) {
        super(activityType, options);
        this.initPoint();
        
    }
    async initPoint() {
        try {
            // vue同一个实例多次触发导致domChangeArray 庞大，进行初始化
            this.domChangeArray = [];
            // 注册当前dom监听
            if (this.options.watchMutation) {
                this.addDocumentListener();
            }
            window.onload = () => {
                this.domChangeArray = [];
                this.init();
            };
            await this.utilClass.runScript(
                `${TRACKER_CONFIG_BASE_URL}${
                    window.location.protocol === 'https:' ? 'prod' : 'test'
                }/${this.activityType}.js?sp=${new Date().getTime()}`
            );
            const pageConfig = window.trackConfig;
            if (!pageConfig) return;
            this.json = pageConfig;
            this.authList = window.trackConfig.authList || [];
            this.init();
            if (this.json.click) this.clickPoint(); // 点击埋点

            // 点击埋点限流
            this.clickEventHandleDebounce = this.utilClass.debounce(
                e => {
                    this.record_click_current_dom_info = e;
                    this.preventDoubllePoint = {};
                    this.clickEventHandle(e);
                },
                this.clickGapTime,
                true
            );
        } catch (error) {
            console.log('可视化埋点出错', error);
        }
    }

    // 监听dom变化
    addDocumentListener() {
        if ('MutationObserver' in window) {
            const mutationObserver = new MutationObserver(mutations => {
                const tmpMutations = mutations;
                if (tmpMutations) {
                    Array.prototype.forEach.call(tmpMutations, mutation => {
                        this.init(this.loopChildList(mutation.target.children, []));
                    });
                }
            });
            mutationObserver.observe(document.body, {
                attributes: true,
                childList: true,
                subtree: true
            });
        } else {
            setTimeout(() => {
                this.init();
            }, 500);
        }
    }
    scrollImp() {
        this.container = document.getElementById('app');
        this.container &&
            this.container.removeEventListener('scroll', () => {
                console.log('移除滚动事件');
            });
        this.container &&
            this.container.addEventListener('scroll', e => {
                if (this.json && this.json.imp) this.impPoint();
            });
        window.onscroll = () => {
            if (this.json && this.json.imp) this.impPoint();
        };
    }

    init(mutations) {
        this.scrollImp();
        if (!mutations || !mutations.length) {
            return;
        }
        setTimeout(() => {
            if (this.json && this.json.imp) {
                // 曝光埋点
                this.impPoint(mutations);
                if (this.domChangeArray) {
                    Array.prototype.forEach.call(this.domChangeArray, mutations => {
                        this.impPoint(mutations);
                    });
                }
            } else {
                this.domChangeArray = [...mutations];
            }
        }, 100);
    }

    impPoint(mutations) {
        const keys = Object.keys(this.json.imp);
        if (mutations && mutations.length) {
            for (const trackId of mutations) {
                if (keys.includes(trackId)) {
                    const data = this.json.imp[trackId];
                    this.impConvert(data, trackId);
                }
            }
        } else {
            for (const item of keys) {
                const data = this.json.imp[item];
                this.impConvert(data, item);
            }
        }
    }

    clickPoint() {
        document.body.addEventListener(
            'click',
            e => {
                try {
                    this.clickEventHandleDebounce(e);
                } catch (e) {
                    console.warn(`可视化埋点点击报错：${e}`);
                }
            },
            true
        );
    }

    async clickEventHandle(e) {
        const trackId = e.target.getAttribute(UNIQUE_SIGN) || '';
        const res = Object.keys(this.json.click).some(e => trackId === e || e.includes(trackId));
        if (res && trackId) {
            const id = trackId;
            const config = this.json.click[id];
            const params = await this.getParamsValue(config);
            this.handlePoint('h5_clk', {
                tgt_event_id: 'super_click',
                tgt_name: config.tgt_name,
                ...params,
                trackId: id
            });
        }
    }
    // 曝光埋点防重
    preventImpPoint(id) {
        return new Promise(resolve => {
            const _nowTime = Number(new Date());
            const _lastTime = this.preventDoubllePoint[id];
            this.preventDoubllePoint[id] = Number(new Date());
            if (_lastTime) {
                // 是否大于设定的值
                const intervalResult = _nowTime - _lastTime > this.exposureGapTime;
                if (intervalResult) {
                    resolve(false);
                }
                resolve(true);
            }
            resolve(false);
        });
    }
    async impConvert(data, id) {
        const dom = document.querySelector(`[${UNIQUE_SIGN}="${id}"]`);
        try {
            if (this.utilClass.isHidden(dom)) return
            if (!dom || (await this.preventImpPoint(id))) {
                return;
            }
            const scrollTop = this.container.scrollTop || 0;
            const scrollResult =
                (dom && dom.offsetTop - scrollTop < document.body.clientHeight) || false;
            // 去重且在可视区域 是多次曝光吗
            if (data.impType !== 'impTimes') {
                if (!scrollResult || this.pointed.includes(id) || data.route !== this.hash) return;
                this.pointed.push(id);
            }
            const params = await this.getParamsValue(data);
            this.handlePoint('h5_element_imp', {
                tgt_event_id: 'h5_element_imp',
                tgt_name: data.tgt_name,
                ...params,
                trackId: id,
                ...this.params
            });
        } catch (error) {
            console.log(error);
        }
    }
}
